<!--
 * @Author: your name
 * @Date: 2020-08-13 20:04:19
 * @LastEditTime: 2022-12-07 10:12:06
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/pay/index.vue
-->
<style scoped lang="sass">
$color1: rgba(20, 196, 188, 1)
$color2: rgba(51, 68, 85, 1)
$color3: #f1f2f3
$color4: rgba(51, 68, 85, 0.75)

.indent_padding
  padding-left: 17px
  padding-right: 17px

.left_footer
  display: flex
  justify-content: center
  align-items: center
  width: 100%
  height: 100%
  color: var(--menu-primary-background-colour) !important
  font-size: 14px
  font-weight:500
  line-height: 18px

.pay
  .content
    .order
      margin: 30px 0

    .item
      margin-top: 45px
      line-height: 19px
      font-size: 16px
      font-weight: 500
      color: var(--menu-primary-text-colour) !important
      padding-left: 17px
      padding-right: 17px

    .order_total
      flex-shrink: 0
      display: flex
      justify-content: space-between
      align-items: center
      height: 20px
      line-height: 20px
      margin-top: -5px
      margin-bottom: 30px
      @extend .indent_padding
      // border-bottom: 1px solid $color3

      .text,
      .price
        color: var(--menu-primary-text-colour) !important
        font-size: 12px
        line-height: 20px

.normal_pay_head
  display: flex
  flex-direction: column
  align-items: center
  margin-top: 30px

  .title
    width: 100%

  .info
    font-size: 10px
    line-height: 10px
    color: $color4

    .title
      margin-bottom: 15px
      font-size: 19px
      font-weight: 500
      line-height: 19px
      color: var(--menu-primary-background-colour) !important
      text-align: center

    .note
      font-size: 10px
      line-height: 10px
      color: var(--menu-primary-text-colour) !important

::v-deep
  .van-button--primary
    background-color: var(--menu-primary-background-colour)
    border: none

  .disabled
    background-color: #ddd !important
</style>

<style lang="sass" scoped>
.sub_total
  display: flex
  flex-direction: column
  padding: 5px 0

  .sub_total_item
    display: flex
    justify-content: space-between
    align-items: center
    font-size: 12px
    line-height: 20px
    color: var(--menu-primary-text-colour) !important
    padding-left: 17px
    padding-right: 17px

.num
  margin-bottom: 27px

.footer_bar
  position: fixed
  bottom: 0
  border-radius: 0 !important

.order_post_paid
  position: relative

  .title
    background: var(--menu-primary-background-colour) !important
    height: 50px
    width: 50px
    border-radius: 50%
    opacity: .2

  .note
    position: absolute
    top: 50%
    left: 50%
    transform: translate3d(-50%, -50%, 0)
    color: var(--menu-primary-background-colour) !important

.header
  font-size: 26px
  line-height: 31px
  margin-bottom: 8px
  margin-top: 20px
  color: var(--menu-primary-background-colour) !important

.subtitle
  padding: 0 45px
  text-align: center
  font-size: 12px
  line-height: 16px
  color: var(--menu-primary-text-colour) !important

.process
  padding-left: 17px
  padding-right: 17px
</style>

<style lang="sass" scoped>
.tab_pay_head
  display: flex
  align-items: center
  flex-direction: column
  margin-top: 24px

  .title
    margin-top: 20px
    line-height: 31px
    font-size: 26px
    color: var(--menu-primary-background-colour) !important

  .tab_pay_user_head,
  .tab_pay_owner_head
    margin-bottom: 50px
    margin-top: 10px
    line-height: 17px
    font-size: 14px
    color: var(--menu-primary-text-colour) !important

  .process
    width: 100%

.alcohol
  padding: 12px 13px
  margin: 10px 17px 0 17px
  background: rgba(var(--menu-primary-background-colour-rgb), .08)
  border: 1px solid var(--menu-primary-background-colour)
  border-radius: 4px

  .text
    font-size: 14px
    color: var(--menu-primary-text-colour)

.title_background
  background: var(--menu-primary-background-colour) !important
  height: 50px
  width: 50px
  border-radius: 50%
  opacity: .2

.tab_pay_footer
  position: fixed
  bottom: 0
  height: 150PX
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  width: 100%
  padding: 0 16px
  border-top: 1px solid #f1f2f3
  background: #fff

.padding_bottom_tab_owner
  padding-bottom: 150PX

.order_more
  width: 100%
  height: 54PX

.manage_tab
  width: 100%
  margin-bottom: 16PX
  height: 54PX
  border: 1px solid var(--menu-primary-background-colour) !important
  background: #fff !important
  color: var(--menu-primary-background-colour) !important
</style>

<template lang="pug">
.pay
  .content.overflow_scroll(
    v-if="order.id"
    :class="{'padding_bottom_tab_owner': isTabOwnerPay}"
  )
    .tab_pay_head
      .order_post_paid
        .title_background
        icon.note(size='35') check
      .title.b Order added to tab
      .tab_pay_owner_head.o6(v-if="isTabOwnerPay") Your current tab is {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ tabInfo.currentTab.amount | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
      .tab_pay_user_head.o6(v-else) Your order has been added to {{ order.details.paymentExtra ? order.details.paymentExtra.tabOwnerName : '' }}’s tab
      Process.process(
        :status="order.status"
          :payamentStatus="order.paymentStatus"
          :orderType="order.details.orderType"
          :type="Number(order.type)"
      )
    .alcohol(v-if="!isFromOrderHistoryToOrderDetail && alcoholText")
      .text {{ alcoholText }}
    .item Order details:
    Items(
      v-for="item in order.itemList"
      :key="item.id"
      :data="item"
      :isPostPaid="isPostPaid"
    )
    .sub_total.ns
      .sub_total_item.o
        div Subtotal:
        div {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ order.subtotal | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
      .sub_total_item.o(v-if="showDiscounts")
        div {{ `Discount`}}
          span(v-if="isRateDiscount") {{ ` (${ discountRate }%)` }}
          span {{ ` ${order.details.discounts.name}:` }}
        div {{ symbolPosition === 'after' ? '-' : '-' + currencySymbol }}{{ (order.id ? order.details.discounts.amount : 0) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
      .sub_total_item.o(v-if="discountAmount")
        div Discount:
        div {{ symbolPosition === 'after' ? '-' : '-' + currencySymbol }}{{ discountAmount | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
      .sub_total_item.o(v-if="order.details.surchargeAmount")
        div {{surchargeHead}}:
        div {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ order.details.surchargeAmount | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
      .sub_total_item.o(v-if="customerMerchantFee !== 0")
        div {{ t('payment_surcharge', 'Venue Surcharge') }}:
        div {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ (order.id ? order.details.customerMerchantFee : 0) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
      .sub_total_item.o(v-if="showTipping")
        div {{ `Tip Amount:` }}
        // @todo wrong field position
        div {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ (order.id ? order.tipAmount : 0) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
    .order_total.ns
      .text.b Total amount paid:
      .price.b {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ order.amount | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
  .tab_pay_footer(v-if="isTabOwnerPay")
    van-button.button.manage_tab.b.ls1(type="primary" @click="manageTab") {{ manageTabText }}
    van-button.button.order_more.b.ls1(type="primary" @click="orderMore") {{ orderMoreText }}
  footer-common.footer_bar(
    v-else
    :text="orderMoreText"
    @clickButton="orderMore"
  )

  bottom-popup-dialog(
    v-model="showDialog"
    :dialog-height="dialogHeight"
    :show-popup-loading="showPopupLoading"
    @changeShow="closeDialog"
  )
    template(v-slot:popup-dialog)
      dialog-content(
        :img-src="logoImgSrc"
        :show-sign-up-page="showSignUpPage"
        :marketing-consent-message="marketingConsentMessage"
        @closeDialog="closeDialog"
        @signUp="signUp"
      )

  marketing-dialog(v-model="showSurveys" :round="false" @closeDialog="closeMarketingDialog")
    template(v-slot:popup-dialog)
      marketing-campaigns(
        ref="marketingCampaigns"
        :img-src="logoImgSrc"
        :marketing-consent-message="marketingConsentMessage"
        :showSurveys="showSurveys"
        :data="campaignsList"
        :isCampaigns="isCampaigns"
        :orderId="orderId"
        @closeDialog="showSurveys = false"
        @signUp="signUp(false)"
      )

  mask-manage-tab(
    :showMask.sync="showManageTabDialog"
  )
</template>

<script>
import Component, { mixins } from 'vue-class-component'
import mixin from '@/utils/mixin'
import { mapState } from 'vuex'
import Items from './component/Items'
import Num from './component/Num'
import DownLoadTax from './component/DownLoadTax'
import DialogContent from './component/DialogContent'
import { customReadyTab, } from 'utils/message'
import { getOrder, getUser, updateUser } from '@/api/product'
import MaskManageTab from 'components/MaskManageTab'
import MarketingCampaigns from './component/MarketingCampaigns'
import MarketingDialog from './component/MarketingDialog'
import dayjs from 'dayjs'
import { formatDecimalNumber, getDefaultCurrencySymbol, getDefaultSymbolPosition } from '@/utils/currency'
import { getLocalizedCustomMessage, t } from '@/utils/language'
import { surchargeName } from '@/utils/surcharge'

@Component({
  filters: {
    fix(val) {
      return val ? formatDecimalNumber(val) : formatDecimalNumber(0)
    }
  },

  watch: {
    $route(val) {
      this.routerName = val.name
    },

    isMarketing(val) {
      // TODO: isMarketing do not go into the url by normal processing
      if (val) { // 这层判断基本是判断是否是第一次进入页面
        const url = window.location.href.replace('&isMarketing=1', '') // 判断之后就重制 url，让页面刷新之后更改 isMarketing 参数
        window.history.pushState({}, 0, url) // 不跳转重写 url
        const time = (Number(this.postWidgetSettings?.displayWaitingTime ?? 1.5)) * 1000
        setTimeout(() => {
          switch (this.isCampaigns) {
            case 0:
              this.showSurveys = false
              this.showDialog = false
              break

            case 1:
            case 3:
              this.showSurveys = true
              this.showDialog = false
              break

            case 2:
              this.showSurveys = false
              this.showDialog = true
              break
          }
        }, time)
      }
    },
  },

  async created() {
    this.$store.commit('showLoading')
    await this.__checkVenueOpenTime()
    this.routerName = this.$route.name
    this.orderNo = this.$route.query.orderNo
    await this._updateOrder()
    this._openTabReadyDialog()
    // 下面代码的顺序要在最后，不然延迟显示弹窗会有时差
    await this.checkAddedMarket()
    this.$store.commit('closeLoading')
  },

  components: {
    Items,
    Num,
    DownLoadTax,
    DialogContent,
    MaskManageTab,
    MarketingDialog,
    MarketingCampaigns
  },

  props: {
    orderId: [String, Number]
  },

  computed: {
    ...mapState(['venueId', 'paymentInfo', 'id', 'isFromOrderHistoryToOrderDetail']),
    ...mapState({
      routerInfo: state => state.venueHome.routerInfo,
      postWidgetSettings: state => state.venueHome.postWidgetSettings,
      customMessageSettings: state => state.venueHome.customMessageSettings,
    }),

    tabInfo() {
      return this.$store.getters.tabInfo(this.venueId)
    },

    discountAmount() {
      let discountAmount = 0
      const spDiscounts = this.order.spDiscounts
      if (spDiscounts && spDiscounts.length) {
        spDiscounts.forEach(item => discountAmount += Number(item.totalAmount))
      }
      return discountAmount
    },

    showDiscounts() {
      if (this.order.id && this.order.details.discounts) {
        const amount = parseFloat(this.order.details.discounts.amount)
        if (amount) return true
      }
      return false
    },

    showTipping() {
      if (this.order.id && this.order.details.enableTip) {
        return true
      }
    },

    isPostPaid() {
      return this.order.type === 2
    },

    discountRate() {
      if (this.order.id) {
        if (this.order.details.discounts) {
          return formatDecimalNumber(parseFloat(this.order.details.discounts.rate))
        } else {
          return formatDecimalNumber(0)
        }
      } else {
        return formatDecimalNumber(0)
      }
    },

    customerMerchantFee() {
      if (this.order.id) {
        return this.order.details.customerMerchantFee
      } else {
        return 0
      }
    },

    isRateDiscount() {
      const PERCENTAGE_TYPE = 'percentage'
      return this.order.details.discounts?.rateType === PERCENTAGE_TYPE
    },

    isTabOwnerPay() {
      const tabPaymentList = [
        // 'payWithTab',
        'payWithOwnTab',
      ]
      return tabPaymentList.includes(this.order?.details.paymentType)
    },

    surchargeHead() {
      const WEEKDAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
      const d = this.order.details
      // createdAtString is already venue-local — do NOT apply .tz()
      const fallbackWeekDay = this.order.createdAtString
        ? WEEKDAYS[dayjs(this.order.createdAtString).day()]
        : undefined
      if (d && d.surchargeAmount && d.surchargeSettings && d.surchargeSettings.type === 'date') {
        return surchargeName({ type: 'date', group: d.surchargeSettings.settings && d.surchargeSettings.settings.group, settings: d.surchargeSettings })
      }
      if (d && d.surchargeAmount && d.surchargeSettings && d.surchargeSettings.type === 'weekly') {
        return surchargeName({ type: 'weekly', weekDay: d.surchargeSettings.weekDay || fallbackWeekDay, settings: d.surchargeSettings })
      }
      if (fallbackWeekDay) {
        return surchargeName({ type: 'weekly', weekDay: fallbackWeekDay })
      }
      return surchargeName({ type: 'date' })
    },

    /**
     * @returns {String} 过敏提示文案
     */
    alcoholText() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      let text = ''
      let type = ''
      if (this.order) {
        const { details, menuType } = this.order
        // 根据订单信息，获取当前的订单类型
        if (details.orderType === 'dine-in' && details.table) type = 'table'
        else if (details.orderType === 'dine-in' && !details.table && menuType === 'normal') type = 'counter'
        else if (details.orderType === 'takeaway' && menuType === 'online') type = 'takeaway'
        else if (details.orderType === 'pickup') type = 'pickup'
        else if (details.orderType === 'delivery') type = 'delivery'
      }
      // 根据订单类型，查看对应的文案信息
      if (type && this.customMessageSettings?.confirmation) {
        const messageEntry = this.customMessageSettings.confirmation[type]
        const message = getLocalizedCustomMessage(messageEntry) ?? ''
        if (messageEntry?.enable) text = message.trim() ? message : ''
      }
      return text
    },

    currencySymbol() {
      return getDefaultCurrencySymbol()
    },

    symbolPosition() {
      return getDefaultSymbolPosition()
    }
  }
})

class TabOrderReceived extends mixins(mixin) {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  isMarketing = false
  orderMoreText = 'ORDER MORE'
  manageTabText = 'MANAGE TAB'
  showManageTabDialog = false
  timer = null
  dialogHeight = 43
  routerName = ''
  order = {}
  orderNo = ''
  showSignUpPage = true
  setTimeout = null
  showSurveys = false
  showDialog = false
  campaignsList = []
  isCampaigns = 0

  manageTab() {
    this._setTabPassCode()
    this._jumpToManageTab()
  }

  _setTabPassCode() {
    const passCode = this.tabInfo.currentTab.phone.slice(-4)
    this.$store.commit('tabPassCode/SET_TAB_PASS_CODE', passCode)
  }

  _jumpToManageTab() {
    this.$router.push({
      path: `/v/${this.venueId}/tab-admin/${this.tabInfo.currentTab.id}/menu`
    })
  }

  orderMore() {
    // clearTimeout for canceling the showDialog
    clearTimeout(this.timer)
    const tableNumber = this.routerInfo.number || this.$route.query?.tableNumber
    if (tableNumber) {
      this.$router.push(`/v/${this.venueId}/home/t/${tableNumber}`)
    } else {
      this.$router.push(`/v/${this.venueId}/home/p`)
    }
  }

  _openTabReadyDialog() {
    const { isReadyTab } = this.$route.query
    if (isReadyTab) {
      const self = this
      this.$createTabMessageDialog({
        $props: customReadyTab,
        $events: {
          click() {
            self.showManageTabDialog = true
          }
        }
      }).show()
    }
  }

  beforeDestroy() {
    clearTimeout(this.setTimeout)
  }

  // 每 10s 获取订单信息
  async _updateOrder() {
    await this._getOrder()
    this.setTimeout = setTimeout(_ => {
      this._updateOrder()
    }, 10000)
  }

  async _postOrder() {
    try {
      const res = await getOrder({
        id: this.orderId
      })
      return res
    } catch {
      this.$store.commit('closeLoading')
    }
  }

  async _getOrder() {
    const res = await this._postOrder()
    this.order = {
      ...res,
      itemList: res.itemList
    }
    this.saveIspostPaid()
    this.saveIsCounterPay()
  }

  saveIspostPaid() {
    const res = this.order.type === 2
    this.$store.commit('saveIspostPaid', res)
  }

  saveIsCounterPay() {
    const res = this.order.details.payAtCounter
    this.$store.commit('saveIsCounterPay', res)
  }

  async checkAddedMarket() {
    const userId = localStorage.getItem('userId')
    const notificationKey = localStorage.getItem('notificationKey') || ''
    if (userId) {
      const res = await getUser({
        id: userId,
        notificationKey: notificationKey,
        venueId: this.venueId
      }).catch(error => {
        console.log(error)
        this.$store.commit('closeLoading')
      })
      const joinMarketingList = res.joinMarketingList || []
      this.addedMarket = joinMarketingList.includes(this.venueId)
      this.campaignsList = res.campaigns
      this.isCampaigns = this._showDialogType()
    } else {
      // if there is not userId, then unShow the dialog
      this.addedMarket = true
    }

    this.isMarketing = Number(this.$route.query.isMarketing) || false
  }

  // 关闭营销的弹窗
  closeMarketingDialog() {
    this.$refs.marketingCampaigns._closeAnswerCampaign()
    this.showSurveys = false
  }

  closeDialog() {
    this.showDialog = false
    this._setPopupOnceTime()
  }

  _setPopupOnceTime() {
    const nowTime = dayjs.tz().format('YYYY-MM-DD')
    const { venueId } = this
    this.$store.commit('signUpDialogOnceTime/SET_SIGN_UP_POPUP_ONCE_TIME', { nowTime, venueId })
  }

  async signUp(isShow = true) {
    this.showPopupLoading = isShow
    await this.addUserToMarket()
    this.closeSignUpPage()
  }

  closeSignUpPage() {
    this.showPopupLoading = false
    this.showSignUpPage = false
  }

  async addUserToMarket() {
    const res = await updateUser({
      id: localStorage.userId,
      joinMarketingConsent: true,
      venueId: this.venueId
    }).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    console.log(res)
  }

  /**
   * 判断返回要显示的弹窗类型
   * @param surveyList {Array} 反馈列表
   * @returns {Numer} 弹窗类型 0: 不显示  1: 营销+反馈  2: 营销  3: 反馈
   */
  _showDialogType(surveyList = []) {
    const isPostHasPaidOrder = this.isPostPaid && (this.routerName === 'my-order') && !this.isCounterPay
    const isPreHasPaidOrder = !this.isPostPaid
    if (!isPostHasPaidOrder && !isPreHasPaidOrder) return 0
    const enableMarketingConsent = this.enableMarketingConsent
    const notAddedMarketYet = !this.addedMarket
    const notTodayPopupOnce = !this._isTodayPopupOnce()
    const isAutoShowDialog = !this.$store.state.isFromOrderHistoryToOrderDetail
    const showMarketingDialog = enableMarketingConsent && notAddedMarketYet && notTodayPopupOnce && isAutoShowDialog
    const showSurveyDialog = isAutoShowDialog && surveyList?.length
    if (showMarketingDialog && showSurveyDialog) return 1
    if (showMarketingDialog && !showSurveyDialog) return 2
    if (!showMarketingDialog && showSurveyDialog) return 3
    return 0
  }

  _isTodayPopupOnce() {
    const nowTime = dayjs.tz().format('YYYY-MM-DD')
    const lastTime = this._getPopupTime()
    return nowTime === lastTime
  }

  _getPopupTime() {
    this.$store.commit('signUpDialogOnceTime/GET_SIGN_UP_POPUP_ONCE_TIME')
    return this.$store.state.signUpDialogOnceTime.popupTime[this.venueId] ?? ''
  }
}

export default TabOrderReceived
</script>
